import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from '../tables/RecordsTable';
import {useBankAccountsSelection} from '../hooks/useBankAccountsSelection';

// FNP-918: the page reads SELECTION and passes it to both consumers — the table
// (which renders the checkboxes) and the header (which renders the batch delete
// button). They are siblings, so the shared parent threads it through.
//
// The state itself lives in the Redux bank-accounts.selection slice (FNP-951),
// so both could read it directly; passing it down keeps RecordsTable driven by
// props and therefore testable without a store. It replaces the
// `useState<BankAccount[]>` this page used to own.
//
// Content is wrapped in SimplePageContentWrapper (§2) — the previous version
// dropped the table straight into SimplePageLayout, so it did not get the
// standard content padding every other module's index page has.
export const IndexPage = () => {
    const selection = useBankAccountsSelection();

    return (
        <SimplePageLayout
            pageHeader={
                <IndexPageHeader
                    selectedIds={selection.selectedIds}
                    onDeleteComplete={selection.handleClearSelection}
                />
            }
        >
            <SimplePageContentWrapper>
                <RecordsTable selection={selection}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
